/* global axios */
import ApiClient from './ApiClient';

class ContactSyncConfigurationAPI extends ApiClient {
  constructor() {
    super('contact_sync_configuration', { accountScoped: true });
  }

  update(data) {
    return axios.patch(this.url, data);
  }

  test(sampleValue, configuration) {
    return axios.post(`${this.url}/test`, {
      ...configuration,
      sample_value: sampleValue,
    });
  }

  syncBase() {
    return axios.post(`${this.url}/sync_base`);
  }

  previewBase() {
    return axios.post(`${this.url}/preview_base`);
  }

  pauseBase() {
    return axios.post(`${this.url}/pause_base`);
  }

  resumeBase() {
    return axios.post(`${this.url}/resume_base`);
  }
}

export default new ContactSyncConfigurationAPI();
